import React, { Fragment, Suspense, lazy } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import arrMenu from "./../../constants/menuRoutes";
import config from "./../../common/config";
import app from "./../../common/app";
import core from "./../../common/core";
import Loader from "./../loader";
import { connect } from "react-redux";

const Home = lazy(() =>
  import(/* webpackChunkName: 'Home' */ "./../../screens/home")
);
const Matches = lazy(() =>
  import(/* webpackChunkName: 'Matches' */ "./../../screens/matches")
);
const Leaderboard = lazy(() =>
  import(/* webpackChunkName: 'Leaderboard' */ "./../../screens/leaderboard")
);
const Rules = lazy(() =>
  import(/* webpackChunkName: 'Rules' */ "./../../screens/rules")
);
const Terms = lazy(() =>
  import(/* webpackChunkName: 'Terms' */ "./../../screens/terms")
);
const NoMatch = lazy(() =>
  import(/* webpackChunkName: 'NoMatch' */ "./../noMatch")
);
const Menu = lazy(() => import(/* webpackChunkName: 'Menu' */ "./../menu"));

let location = window.location.href;
let ObjRoute = {};
ObjRoute[config.enumStaticUrls.home] = Home;
ObjRoute[config.enumStaticUrls.matches] = Matches;
ObjRoute[config.enumStaticUrls.leaderboard] = Leaderboard;
ObjRoute[config.enumStaticUrls.rules] = Rules;
ObjRoute[config.enumStaticUrls.terms] = Terms;

const queryParams = app.getQueryParamsObject;
const isWebview = queryParams.webview;
const platform_ID = queryParams.platform_type;

const doDefaultNavigation = (props) => {
  const path = props.sPath;
  const routeObject = props.routeObject;
  const DefaultComponent = props.DefaultComponent;
  const trans = props.trans;
  const userEotStatus = props.tourStatus.eot;
  const cookie = app.getLoginCookie();
  let isAuthorize = routeObject.validator
    ? routeObject.validator(routeObject, cookie, userEotStatus)
    : true;
  let sTitle = "";

  document.title =
    trans && trans[routeObject.titleTransKey]
      ? trans[routeObject.titleTransKey]
      : routeObject.titleTransKey;

  if (!isAuthorize) {
    let sRedirect = config.redirectDefault.replace(
      "{{lang}}",
      config.CURRENT_LANGUAGE
    );
    sRedirect = `${sRedirect}${
      isWebview ? `?webview=true&platform_type=${platform_ID}` : ""
    }`;
    return <Redirect to={sRedirect} />;
  }

  sTitle = document.title;
  config.CURRENT_PATH = props.location ? props.location.pathname : path;
  let CompReturn = null;
  if (!CompReturn) {
    CompReturn = <DefaultComponent {...props} />;
  }
  const fResp = app.googleAnalyticsTracking(
    sTitle,
    /* config.URL_BASE + */ (
      config.CURRENT_PATH + window.location.search
    ).toLowerCase()
  );
  if (fResp) {
    let ObjEventParam = {
      page: routeObject.path,
      source: (config.CURRENT_PATH + window.location.search).toLowerCase(),
    };
  }
  //console.log((config.URL_BASE + config.CURRENT_PATH + window.location.search).toLowerCase());
  return CompReturn;
};

class Routes extends React.Component {
  constructor() {
    super();
    this.state = {
      myRoutes: [],
      isDateUpdate: null,
      popupNode: null,
      jMode: config.enumGameMode.live,
    };

    let eventValidators = app.eventValidators;
    let eventValidatorsLoggedIn = app.eventValidatorsLoggedIn;

    this.routes = [];

    //login menu add kiya hai
    for (let jN = 0; jN < (arrMenu || []).length; jN++) {
      let row = arrMenu[jN];
      row.validator = eventValidators;
      if (row.isAuthorize === 1) {
        row.validator = eventValidatorsLoggedIn;
      }
      this.routes.push({
        ...row,
        path: row.link ? row.link.toLowerCase() : "",
        component: ObjRoute[row.link ? row.link.toLowerCase() : ""],
        validator: row.validator,
      });
    }
  }

  render() {
    const self = this;
    const { nodeLoader } = self.props;
    let myRoutes = self.routes.map((el, index) => {
      let component = el.component;
      let sPath = el.path;
      let propsRoute = {
        DefaultComponent: component,
        sPath: sPath,
        routeObject: el,
        ...self.props,
      };
      if (component) {
        // console.log(config.URL_BASE + el.path);
        return (
          <Route
            // exact
            key={index}
            path={config.URL_BASE + el.path}
            render={(props) => {
              return doDefaultNavigation({ ...props, ...propsRoute });
            }}
          />
        );
      } else {
        return null;
      }
    });

    return (
      <BrowserRouter>
        <Suspense fallback={nodeLoader}>
          <Menu />
          <Switch>
            {myRoutes}
            <Route component={NoMatch} />
          </Switch>
          {/* <GDPR /> */}
        </Suspense>
      </BrowserRouter>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    tourStatus: state.appData.tourStatus,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);
